const translations = Object.assign(
  {},
  require("../../node_modules/front-commerce/translations/en.json"),
  require("../../node_modules/front-commerce/theme-chocolatine/translations/en.json"),
  require("../../node_modules/front-commerce/modules/auth-external-login/translations/en.json"),
  require("../../translations/en.json")
);
module.exports = translations;
